import { render } from "./TeamListCard.vue?vue&type=template&id=22a68a16&scoped=true"
import script from "./TeamListCard.vue?vue&type=script&lang=js"
export * from "./TeamListCard.vue?vue&type=script&lang=js"

import "./TeamListCard.vue?vue&type=style&index=0&id=22a68a16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22a68a16"

export default script